module.exports = __webpack_public_path__ + "static/img/JEEP.fd62845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/JEEP.png
// module id = ko9d
// module chunks = 1